require('../../style/base.css');
require('../../info/index.css');
require('../../icon/index.css');
require('../../loading/index.css');
require('../../button/index.css');
require('../index.css');


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/goods-action-button/style/index.js
// module id = NenW
// module chunks = 18